import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {MessageService} from '../../../services/message.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
    selector: 'ngx-widget-setup-switch',
    templateUrl: './widget.setup.switch.component.html',
    styleUrls: ['./widget.setup.switch.component.scss'],
})

export class WidgetSetupSwitchComponent implements OnInit {

    form: FormGroup;
    data: any;
    availableOutlets: Array<String> = [];
    availableSwitches: Array<String> = [];
    addWidget: boolean;

    constructor(private activeModal: NgbActiveModal,
                private messageService: MessageService,
                private formBuilder: FormBuilder) {

        const self = this;

        this.data = {
            name: 'Switch',
            icon: 'nb-lightbulb',

        };


        this.messageService.getGatewayPhisicalDevices(function(status, obj){

            // console.log({status, obj});

            if (status === true) {
                for (let i = 0; i < obj.length; ++i) {

                    const dev = obj[i];

                    if (dev.vendor === 'RFM69' && (dev.deviceType === 2 || dev.deviceType === 4) ) {
                        self.availableOutlets.push(dev.vendor + ':' + dev.deviceType + ':' + dev.deviceId);
                    }else if (dev.vendor === 'SHELLY' && dev.deviceType === 1) {
                        self.availableOutlets.push(dev.vendor + ':' + dev.deviceType + ':' + dev.deviceId + ':relay');


                    }else if (dev.vendor === 'RFM69' && dev.deviceType === 3) {

                        self.availableSwitches.push(
                            dev.vendor + ':' + dev.deviceType + ':' + dev.deviceId + ':btn:0:shortPress');
                        self.availableSwitches.push(
                            dev.vendor + ':' + dev.deviceType + ':' + dev.deviceId + ':btn:0:longPress');
                        self.availableSwitches.push(
                            dev.vendor + ':' + dev.deviceType + ':' + dev.deviceId + ':btn:1:shortPress');
                        self.availableSwitches.push(
                            dev.vendor + ':' + dev.deviceType + ':' + dev.deviceId + ':btn:1:longPress');
                    }
                }
            }

            // self.availableOutlets.push('TEST1');
            // self.availableSwitches.push('TEST2');


            // console.log('Available devices:');
            // console.log(self.availableControls);
            // console.log(self.availableSensors);
        });

    }

    ngOnInit() {
        this.form = this.formBuilder.group({
            widgetName: [null, Validators.required],
            icon: [null, Validators.required],
            source: [null, Validators.required],
            control: [null, Validators.required],
        });


        if (this.data['id'] !== undefined) {
            this.addWidget = false;
        }else {
            this.addWidget = true;
        }
    }

    onSubmit() {
        const self = this;

        self.messageService.saveWidget('switch', self.data);
        self.messageService.syncAllWidgets();
        self.activeModal.close();

    }

    closeModal() {
        this.activeModal.close();
    }


    // private pad(i: number): string {
    //     return i < 10 ? `0${i}` : `${i}`;
    // }

}



// WEBPACK FOOTER //
// /app/src/app/@core/component/add-widget/modal/widget.setup.switch.component.ts